import { css } from 'styled-components';
import { INACTIVE_GRAY } from '../../colors';
import { isDefined } from '../../helpers/defined';
import { userSelectNoneStyle } from '../../tokens/user-select';
import { baseEllipsisStyle } from '../../tokens/ellipsis';
import { baseHyphensStyle } from '../../tokens/hyphens';
import { textAlign } from '../../style/text-align';
import { wordBreak } from '../../style/word-break';
export const baseTypographyMixin = css`
  ${({
  shadowed
}) => shadowed ? `text-shadow: 0 2px 4px rgba(63, 65, 68, 0.3);` : ''}
  ${({
  muted
}) => muted ? `color: ${INACTIVE_GRAY};` : ''}
  ${({
  strong,
  bold
}) => strong || bold ? `font-weight: 600;` : ''}
  ${({
  italic
}) => italic ? `font-style: italic;` : ''}
  ${({
  textAlign: value
}) => isDefined(value) ? textAlign(value) : ''}
  ${({
  wordBreak: value
}) => isDefined(value) ? wordBreak(value) : ''}
  ${({
  textAlignCenter
}) => textAlignCenter ? `text-align: center;` : ''}
  ${({
  textAlignLeft
}) => textAlignLeft ? `text-align: left;` : ''}
  ${({
  textAlignRight
}) => textAlignRight ? `text-align: right;` : ''}
  ${({
  userSelectNone
}) => userSelectNone ? userSelectNoneStyle : ''}
  ${({
  ellipsis
}) => ellipsis ? baseEllipsisStyle : ''}
  ${({
  hyphens
}) => hyphens ? baseHyphensStyle : ''}
`;
export const baseTypographyKeys = ['color', 'negative', 'inverse', 'shadowed', 'muted', 'strong', 'bold', 'italic', 'textAlign', 'wordBreak', 'textAlignCenter', 'textAlignLeft', 'textAlignRight', 'userSelectNone', 'ellipsis', 'hyphens'];